import { render, staticRenderFns } from "./xsign.vue?vue&type=template&id=688afece&scoped=true&"
import script from "./xsign.vue?vue&type=script&lang=js&"
export * from "./xsign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688afece",
  null
  
)

export default component.exports